import styled, { css } from 'styled-components'
import { TBodyProps, TDProps, THProps } from './interface'

export const TD = styled.td<TDProps>`
  text-align: ${({ textAlign }) => textAlign};
  padding: ${({ theme }) => theme.space.xs};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  ${({ theme, basic }) =>
    basic &&
    css`
      border-bottom: 1px solid ${theme.palette.gray100};
    `}
`

export const TBody = styled.tbody<TBodyProps>`
  tr {
    &:nth-child(even) {
      background-color: ${({ theme, basic }) => (basic ? 'none' : theme.palette.blue10)};
    }

    &:hover {
      background-color: ${({ theme, basic }) => (basic ? 'none' : theme.palette.blue20)};
    }
  }
`

export const TH = styled.th<THProps>`
  text-align: ${({ textAlign }) => textAlign};
  color: ${({ theme }) => theme.palette.gray100};
  padding: ${({ theme }) => `${theme.space.md} ${theme.space.xs}`};
  border-bottom: ${({ theme, basic }) => (basic ? 'none' : `1px solid ${theme.palette.gray100}`)};
  text-transform: none !important; 
`

export const TableTag = styled.table`
  width: 100%;
  border-spacing: 0px;
  overflow-x: scroll;
`

export const TableBox = styled.div`
  overflow-x: auto;
  margin-bottom: ${({ theme }) => theme.space.sm};
  padding-bottom: ${({ theme }) => theme.space.sm};

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: ${({ theme }) => theme.layout.xxs};
    border: 1px solid ${({ theme }) => theme.palette.blueGray60};
    border-radius: ${({ theme }) => theme.space.xs};
  }

  &::-webkit-scrollbar-thumb {
    width: ${({ theme }) => theme.layout.xxs};
    height: ${({ theme }) => theme.layout.sm};
    border-radius: ${({ theme }) => theme.space.xs};
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`
